export const dictionary = {
	de: {
		Absence: 'Abwesenheit | Abwesenheiten',
		AbsenceType: 'Abwesenheit-Art',
		Activity: 'Tätigkeit',
		ActivityType: 'Tätigkeit-Art',
		ActivityCategory: 'Tätigkeit-Kategorie',
		Organization: 'Organisation | Organisationen',
		CrudOptionPermission: 'CRUD-Option-Permission',
		Customer: 'Kunde | Kunden',
		CustomerType: 'Kunden-Art',
		CustomerStatus: 'Kunden-Status',
		DrivingLicense: 'Führerschein',
		Gender: 'Anrede',
		Group: 'Rolle | Rollen',
		LessonsLearned: 'Erkenntnisse',
		Login: 'Benutzer',
		Person: 'Kontakt | Kontakte',
		Project: 'Projekt | Projekte',
		ProjectCategory: 'Projekt-Kategorie',
		ProjectStatus: 'Projekt-Status',
		ProjectType: 'Projekt-Art',
		RideRecord: 'Fahrtaufzeichnung | Fahrtaufzeichungen',
		Weather: 'Wetter',
		WeatherRecord: 'Wetteraufzeichnung | Wetteraufzeichungen',
		Worker: 'Mitarbeiter | Mitarbeiter',
		WorkerContractualRelationship: 'Vertragsverhältnis',
		WorkerDivision: 'Abteilung',
		WorkerOperationArea: 'Mitarbeiter-Einsatzgebiet',
		WorkerProfession: 'Beruf',
		WorkerQualification: 'Mitarbeiter-Qualifikation',
		WorkerSkillLevel: 'Mitarbeiter-Funktion',
		WorkerStatus: 'Mitarbeiter-Status',
		WorkerType: 'Mitarbeiter-Art',
		WorkRecord: 'Arbeitserfassung | Arbeiterfassungen',
		WorkRecordDispute: 'Arbeitserfassung-Beschwerde',
		WorkerTimeReport: 'Tagesbericht | Tagesberichte',
		WorkTime: 'Arbeitszeit | Arbeitszeiten',
		ProjectTimeReport: 'Baustellenbericht | Baustellenberichte',
	},

	en: {
		Absence: 'Absence | Absences',
		AbsenceType: 'Absence-Type',
		Activity: 'Activity',
		ActivityType: 'Activity Type',
		ActivityCategory: 'Activity Category',
		Organization: 'Organization | Organizations',
		CrudOptionPermission: 'CRUD-Option-Permission',
		Customer: 'Customer | Customers',
		CustomerType: 'Customer Type',
		CustomerStatus: 'Customer Status',
		DrivingLicense: 'Driving License',
		Gender: 'Salutation',
		Group: 'Role | Roles',
		LessonsLearned: 'Lessons Learned',
		Login: 'User',
		Person: 'Contact | Contacts',
		Project: 'Project | Projects',
		ProjectCategory: 'Project Category',
		ProjectStatus: 'Project Status',
		ProjectType: 'Project Type',
		RideRecord: 'Ride Record | Ride Records',
		Weather: 'Weather',
		WeatherRecord: 'Weather Record | Weather Records',
		Worker: 'Worker | Workers',
		WorkerContractualRelationship: 'Contractual Relationship',
		WorkerDivision: 'Worker Division',
		WorkerOperationArea: 'Worker Operation Area',
		WorkerProfession: 'Worker Profession',
		WorkerQualification: 'Worker Qualification',
		WorkerSkillLevel: 'Worker Skill Level',
		WorkerStatus: 'Worker Status',
		WorkerType: 'Worker Type',
		WorkRecord: 'Work Record | Work Records',
		WorkRecordDispute: 'WorkRecordDispute',
		WorkTime: 'Work Time',
		ProjectTimeReport: 'Daily Work Record | Daily Work Records',
	},
};
